const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function digits(str) {
  return (str || '').replace(/\D/g, '');
}

function isEmail(v) {
  return EMAIL_RE.test(v.trim());
}

function isPhone(v) {
  const s = v.replace(/[\s\-().]/g, '');
  return /^\+?6[14]\d{7,10}$/.test(s) || /^0\d{7,10}$/.test(s);
}

export function validate(f, country) {
  const e = {};

  if (!f.bizName.trim()) e.bizName = 'Registered business name is required.';

  const abnD = digits(f.abn);
  if (!f.abn.trim()) e.abn = country === 'AU' ? 'ABN is required.' : 'NZBN is required.';
  else if (country === 'AU' && abnD.length !== 11) e.abn = 'ABN must be exactly 11 digits.';
  else if (country === 'NZ' && abnD.length !== 13) e.abn = 'NZBN must be exactly 13 digits.';

  if (!f.repFirst.trim()) e.repFirst = 'First name is required.';
  if (!f.repLast.trim()) e.repLast = 'Surname is required.';
  if (!f.repEmail.trim()) e.repEmail = 'Email address is required.';
  else if (!isEmail(f.repEmail)) e.repEmail = 'Enter a valid email address.';
  if (!f.repPhone.trim()) e.repPhone = 'Phone number is required.';
  else if (!isPhone(f.repPhone)) e.repPhone = 'Enter a valid AU or NZ phone number.';

  if (f.opsEmail.trim() && !isEmail(f.opsEmail)) e.opsEmail = 'Enter a valid email address.';
  if (f.opsPhone.trim() && !isPhone(f.opsPhone)) e.opsPhone = 'Enter a valid AU or NZ phone number.';

  if (!f.remitEmail.trim()) e.remitEmail = 'Remittance email address is required.';
  else if (!isEmail(f.remitEmail)) e.remitEmail = 'Enter a valid email address.';
  if (!f.street.trim()) e.street = 'Street address is required.';
  if (!f.city.trim()) e.city = 'City is required.';
  if (country === 'AU' && !f.state.trim()) e.state = 'State is required.';
  if (!f.postcode.trim()) e.postcode = 'Postcode is required.';

  if (country === 'AU') {
    const bsbD = digits(f.bsb);
    if (!f.bsb.trim()) e.bsb = 'BSB is required.';
    else if (bsbD.length !== 6) e.bsb = 'BSB must be 6 digits.';
    const accD = digits(f.account);
    if (!f.account.trim()) e.account = 'Account number is required.';
    else if (accD.length < 6 || accD.length > 9) e.account = 'Account number must be 6 to 9 digits.';
  } else {
    const nzD = digits(f.nzAccount);
    if (!f.nzAccount.trim()) e.nzAccount = 'Bank account is required.';
    else if (nzD.length !== 15 && nzD.length !== 16) e.nzAccount = 'Bank account must be 15 or 16 digits.';
  }

  return e;
}

export const ERROR_ORDER = [
  'bizName', 'abn', 'repFirst', 'repLast', 'repEmail', 'repPhone',
  'opsEmail', 'opsPhone', 'remitEmail', 'street', 'city', 'state',
  'postcode', 'bsb', 'account', 'nzAccount', 'accept',
];

export function initFields(data) {
  const country = data.country;
  return {
    bizName: '', abn: '',
    repFirst: '', repLast: '', repEmail: '', repPhone: '',
    opsFirst: '', opsLast: '', opsEmail: '', opsPhone: '',
    remitEmail: '', street: '',
    city: country === 'NZ' ? 'Auckland Central' : (data.city || 'South Yarra'),
    state: country === 'AU' ? (data.state || 'Victoria') : '',
    postcode: country === 'NZ' ? '1010' : (data.postcode || '3141'),
    bsb: '', account: '', nzAccount: '',
  };
}
